import { useWindowSize } from '@websolutespa/bom-mixer-hooks';
import { clamp, LlmBlock } from '@websolutespa/bom-mixer-llm';
import { useRef } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { CustomCard, LlmChunkCustomCard } from '../CustomCard/custom-card';
import style from './custom-card-group.module.scss';

export type LlmChunkCustomCardGroup = {
  type: 'customCardGroup';
  id: string;
  items: LlmChunkCustomCard[];
};

const ArrowIcon = (
  <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="-0.5" y="0.5" width="55" height="55" rx="27.5" transform="matrix(-1 0 0 1 55 0)" fill="#003A6B" />
    <rect x="-0.5" y="0.5" width="55" height="55" rx="27.5" transform="matrix(-1 0 0 1 55 0)" stroke="white" />
    <path d="M21.9385 21.5C23.0381 22.9562 24.7633 23.956 27.8604 25.1113C30.8443 26.1889 33.8971 27.0808 37 27.7812V28.2285C33.8921 28.931 30.8382 29.8388 27.8604 30.9463C24.7633 32.1016 23.0482 33.0826 21.9385 34.5H21C22.8562 31.3058 22.8659 29.2278 23.0273 28.2764V28.1602H23.0381C23.0489 28.0569 23.0489 27.9528 23.0381 27.8496V27.7334C22.8666 26.7819 22.8562 24.7039 21 21.5H21.9385Z" fill="white" />
  </svg>
);

export const CustomCardGroup: React.FC<LlmBlock<LlmChunkCustomCardGroup>> = (props) => {
  const { item } = props;

  useWindowSize();

  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const swiperProps = {
    modules: [Navigation],
    spaceBetween: clamp(16, 32),
    slidesPerView: 1,
    watchOverflow: true,
    navigation: {
      prevEl: navigationPrevRef.current,
      nextEl: navigationNextRef.current,
    },
    breakpoints: {
      630: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3.2,
      },
      1280: {
        slidesPerView: 4.2,
      },
    },
  };

  return (
    <div className={style.customCardGroup}>
      <Swiper {...swiperProps}>

        {item.items.map((item, i) => (
          <SwiperSlide key={i} className={style.customCardGroupSlide}>
            <CustomCard {...props} item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={style.customCardGroupNav}>
        <button className={style.customCardPrev} ref={navigationPrevRef}>{ArrowIcon}</button>
        <button className={style.customCardNext} ref={navigationNextRef}>{ArrowIcon}</button>
      </div>
    </div>
  );
};

